class Button extends PIXI.Sprite {
	constructor(tex: PIXI.Texture) {
		super(Assets.ui.button);
		centerFrickingSprite(this);
		this.interactive = true;
		this.on('pointerdown', this.clicked);
		this.on('pointerover', this.over);
		this.on('pointerout', this.out);
		let icon = new PIXI.Sprite(tex);
		centerFrickingSprite(icon);
		this.icon = icon;
		icon.interactive = false;
		super.addChild(icon);
		this.setEnabled(true);
	}

	public onClick = new Signal<() => void>();
	private _enabled: boolean;
	public icon: PIXI.Sprite;

	over = (event: PIXI.interaction.InteractionEvent) => {
		if (!this._enabled) {
			return;
		}
		this.texture = Assets.ui.buttonOver;
	};

	out = (event: PIXI.interaction.InteractionEvent) => {
		if (!this._enabled) {
			return;
		}
		this.texture = Assets.ui.button;
	};
	clicked = (event: PIXI.interaction.InteractionEvent) => {
		if (!this._enabled) {
			return;
		}
		if (event) {
			event.stopPropagation();
		}
		this.texture = Assets.ui.buttonDown;
		setTimeout(() => {
			this.texture = Assets.ui.button;
		}, 200);
		this.onClick.emit();
	};

	setEnabled(enabled: boolean): void {
		if (enabled == this._enabled) {
			return;
		}
		this._enabled = enabled;
		this.interactive = enabled;
		if (!enabled) {
			let tintColor = 0x444444;
			this.tint = tintColor;
			this.icon.tint = tintColor;
		} else {
			this.tint = 0xFFFFFF;
			this.icon.tint = 0xFFFFFF;
		}
	}

	hpBar: ProgressBar;

	setProgress(progress: number) {
		if (!this.hpBar) {
			this.hpBar = new ProgressBar();
			this.addChild(this.hpBar);
			this.hpBar.view = new PIXI.display.View(this.hpBar);
			this.hpBar.view.parentLayer = Game.uiLayer;
			this.hpBar.position.set(0, 55);
		}
		this.hpBar.setProgress(progress);
	}
}
